import React from 'react';
import './ListTicketChatMessage.css';
import { Tooltip } from '@material-ui/core';

import { getDisplayOptionBySetting } from './handler/ChatBoxHandler';

export default function DisplayOptionBySetting({
    label,
    optionDisplayLength,
    onClickHandler,
    isMaximizedPanel,
    key
}) {
    label = label.trim();
    if (getDisplayOptionBySetting(label, optionDisplayLength) === label) {
        return (
            <p
                key={`${key}`}
                className={`option-form ${isMaximizedPanel ? 'maximized-form' : 'minimized-form'}`}
                onClick={e => {
                    onClickHandler();
                }}
            >
                {getDisplayOptionBySetting(label, optionDisplayLength)}
            </p>
        )
    }
    
    return (
        <Tooltip title={label} placement="top" arrow>
            <p
                key={`${key}`}
                className={`option-form ${isMaximizedPanel ? 'maximized-form' : 'minimized-form'}`}
                onClick={e => {
                    onClickHandler();
                }}
            >
                {getDisplayOptionBySetting(label, optionDisplayLength)}
            </p>
        </Tooltip>
    );
}
